import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { updateContext } from "@insite/client-framework/Context";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    chain as setFulfillmentMethodChain,
    UpdateContext as DefaultSetFMUpdateContext,
} from "@insite/client-framework/Store/Context/Handlers/SetFulfillmentMethod";
import {
    chain as updatePickUpWarehouseChain,
    UpdateContext as DefaultUPWUpdateContext,
} from "@insite/client-framework/Store/Context/Handlers/UpdatePickUpWarehouse";
import { promoteContextCookiesToSharedDomain } from "@tSurya/Handlers/SharedCookieContext";

const SetFulfillmentMethodUpdateContext: typeof DefaultSetFMUpdateContext = props => {
    updateContext({
        fulfillmentMethod: props.parameter.fulfillmentMethod,
        settings: getSettingsCollection(props.getState()),
    });
    promoteContextCookiesToSharedDomain();
};

replaceInChain(setFulfillmentMethodChain, DefaultSetFMUpdateContext, SetFulfillmentMethodUpdateContext);

const UpdatePickUpWarehouseUpdateContext: typeof DefaultUPWUpdateContext = props => {
    updateContext({
        pickUpWarehouseId: props.parameter.pickUpWarehouse.id,
    });
    promoteContextCookiesToSharedDomain();
};

replaceInChain(updatePickUpWarehouseChain, DefaultUPWUpdateContext, UpdatePickUpWarehouseUpdateContext);
